import { Button } from "react-bootstrap";
import { DateHelper } from "../../../../../helper";
import { ApprovalStatus, FontFa } from "../../../../../components";
import { ColumnsType } from "antd/lib/table";
import useExportDocxFile from "../TemplateDocx/useExportDocxFile";
import { useState } from "react";
import { codeProcessRequestTypes } from "../../../info-technology-process/code-process/codeRequestType";
import { TableHelpers } from "../../../../../helper/TableHelper";
import { requestStatus } from "../../../../../constants";

export const useVehicleColumn = () => {
  const [currentItem, setCurrentItem] = useState<any>();
  const { exportForm } = useExportDocxFile({ item: currentItem, docType: 1 });

  const handleSubmit = (item: any) => {
    exportForm(item);
  };

  const columns: ColumnsType<any> = [
    {
      title: "Mã YC",
      dataIndex: "id",
      key: "id",
      align: "center" as const,
      width: "100px",
      ...TableHelpers.searchInput({ dataIndex: "id" }),
    },
    {
      title: "Ngày tạo",
      dataIndex: "createdDateTime",
      key: "createdDateTime",
      render: (text: string) => DateHelper.formatDateToString(text),
      align: "center" as const,
      width: "120px",
      ...TableHelpers.searchRangePicker({ dataIndex: "createdDateTime" }),
    },
    {
      title: "Người tạo",
      dataIndex: "createdByName",
      key: "createdByName",
      width: "200px",
      ...TableHelpers.searchInput({ dataIndex: "createdByName" }),
    },
    {
      title: "Yêu cầu",
      dataIndex: "eRequestType",
      key: "eRequestType",
      render: (text: string) => (
        <span className="flag success">{text && codeProcessRequestTypes.find((o) => o.value === text)?.label}</span>
      ),
      width: "80px",
    },
    {
      title: "Mô tả",
      dataIndex: "eDescription",
      key: "eDescription",
      ...TableHelpers.searchInput({ dataIndex: "eDescription" }),
    },
    {
      title: "Trạng thái",
      dataIndex: "eRequestStatus",
      key: "eRequestStatus",
      width: "120px",
      render: (text: string) => <ApprovalStatus status={text} />,
      filters: [
        {
          text: "Đang đợi duyệt",
          value: requestStatus.submitted,
        },
        {
          text: "Đã hoàn tất",
          value: requestStatus.completed,
        },
        {
          text: "Đang thực hiện",
          value: requestStatus.inProgress,
        },
      ],
      onFilter: (status: any, record) => record.eRequestStatus.indexOf(status) === 0,
    },
    {
      title: "Xuất tài liệu",
      dataIndex: "export",
      key: "export",
      align: "center" as const,
      width: 120,
      render: (text: string, record: any) => (
        <Button
          title={"Xuất file"}
          className=""
          variant="outline-info"
          onClick={(e: any) => {
            e.stopPropagation();
            setCurrentItem(record);
            handleSubmit(record);
          }}
        >
          <FontFa name="faFileWord" size={"xs"} />
        </Button>
      ),
    },
  ];
  return { columns };
};
